import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';

import CustomKeycloakProvider from './security/CustomKeycloakProvider';

import { Provider } from 'react-redux';
import store from './store';

import { Chart, registerables } from 'chart.js';

import Routes from './routes/Routes';

import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';

import './assets/sass/style.scss';

Chart.register(...registerables);
Chart.defaults.responsive = true;
Chart.defaults.plugins.title.display = true;
Chart.defaults.plugins.title.font.size = 18;

const helmetContext = {};

ReactDOM.render( 
  <CustomKeycloakProvider>
    <Provider store={store} >
      <HelmetProvider context={helmetContext} >
        <ThemeProvider theme={theme} >
          <Routes />
        </ThemeProvider>
      </HelmetProvider>
    </Provider>
  </CustomKeycloakProvider>,
  document.getElementById('root')
);